<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>STEP 3</div>
				<h2 waHeading="l" waText>Bootstrap</h2>
				<p waBody="m" waColorText="quiet" waText>Start the runtime with a single method call &mdash; or let the build plugin handle everything.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>How you bootstrap depends on your mode. Angular mode uses a build plugin that generates the entire Angular project during your build. SSR mode starts the GuicedEE runtime with a Vert.x HTTP server.</p>
				<div *ngIf="!useGradle" class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Angular mode &mdash; Maven plugin &#40;pom.xml&#41;</div>
					<markdown [data]="mdContent_30" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div *ngIf="useGradle" class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Angular mode &mdash; Gradle plugin &#40;build.gradle.kts&#41;</div>
					<markdown [data]="mdContent_31" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>The plugin discovers your annotated classes, generates TypeScript, installs npm dependencies, and runs the Angular CLI &mdash; all in one build step.</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>SSR mode &mdash; Boot.java &#40;Vert.x server&#41;</div>
					<markdown [data]="mdContent_32" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
	</div>
</div>